import { ganttAPI } from '../../../../utils/customGanttPlugin';
import { isGrouped, getColorByStatus } from '../../GanttVisualization.helper';
import {
  getTaskStatus,
  updateProgressStatus,
  formatProgress,
  findReferences,
  getExpectedProgress
} from './utils';
import { renderNonTask } from './template';
import { getIsOdd } from '../common/validators';

const renderProgress = (task, t, onlyRead) => {
  const gantt = window.ganttVisualization;
  const activities = window.activities;
  const { activityReference, taskFromLookahead } = findReferences(
    task,
    activities
  );

  if (!task || task.is_milestone || isGrouped()) return '';

  if (!task.isTask) return renderNonTask(task, t);

  let hasChild;
  if (gantt.hasChild) {
    hasChild = gantt.hasChild(task.id);
  }

  task.expected = getExpectedProgress(
    taskFromLookahead,
    ganttAPI,
    activityReference.calendarId
  );

  taskFromLookahead.status = getTaskStatus(task);
  task.status = taskFromLookahead.status;

  const progressColor = updateProgressStatus(taskFromLookahead);
  taskFromLookahead.progressColor = progressColor;

  return `
        <div class="${getIsOdd({ gantt, task }, 'progress') ? 'odd-col' : 'non-odd-col'}" 
         style="font-weight: ${hasChild ? '600' : '100'}; color: ${getColorByStatus(task)}; 
         cursor: ${onlyRead ? 'not-allowed' : 'pointer'};">
         ${formatProgress(task.progress, t('lang'))}
        </div>
            `;
};

export default renderProgress;
